import styled from 'styled-components';

import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex: 1;
`;
